import { Link } from "react-router-dom";
import { FiArrowUpRight, FiExternalLink, FiMail, FiShield } from "react-icons/fi";
import SocialIconLink from "../common/SocialIconLink.jsx";
import { socialLinks } from "../../data/navigation.js";
import { siteContent } from "../../data/siteContent.js";

export default function ClientFooter() {
  return (
    <footer className="client-footer" aria-label="Magdump footer">
      <div className="footer-brand-panel">
        <p>{siteContent.footer.summary}</p>
        <div className="footer-status">
          <FiShield aria-hidden="true" />
          <span>{siteContent.footer.status}</span>
        </div>
      </div>

      <div className="footer-nav-grid">
        {siteContent.footer.columns.map((column) => (
          <nav key={column.title} aria-label={`${column.title} footer links`}>
            <h2>{column.title}</h2>
            {column.links.map((link) => (
              <Link key={`${column.title}-${link.label}`} to={link.to}>
                {link.label}
                <FiArrowUpRight aria-hidden="true" />
              </Link>
            ))}
          </nav>
        ))}
      </div>

      <div className="footer-contact-panel">
        <h2>Signal Interest</h2>
        <a href={`mailto:${siteContent.contact.email}?subject=Magdump%20launch%20interest`}>
          <FiMail aria-hidden="true" />
          {siteContent.contact.email}
        </a>
        <div className="footer-socials" aria-label="Magdump social links">
          {socialLinks.map((item) => (
            <SocialIconLink key={item.label} {...item} />
          ))}
          <SocialIconLink to="/contact" label="Contact page" Icon={FiExternalLink} />
        </div>
      </div>

      <div className="footer-legal" aria-label="Purchase status">
        <span>© {new Date().getFullYear()} Magdump</span>
        {siteContent.footer.legal.map((item) => (
          <span key={item}>{item}</span>
        ))}
      </div>
    </footer>
  );
}
